import firebase from "./config";
// import { log } from "@wigxel/utils";

const root = firebase.database()

export const voteForUser = (category, person, userId) => {
  return new Promise((res, rej) => {
    firebase
      .database()
      .ref("votes/" + category)
      .push({ nominee: person, voter: userId } , error => {
        if (error) rej(error);
        res();
      });
  });
};

export const addVoterEmail = (email) => {
  return new Promise((res, rej) => {
    const userId = root.ref().child("voters").push().key

    root.ref("voters/" + userId).set(email, error => {
        if (error) rej(error);
        res(userId);
      });
  });
};

export const emailExist = (email) => new Promise((res, rej) => {
  root.ref("/voters").orderByValue().equalTo(email).once('value', (snapshot) => {
    const data = snapshot.val();
    data == null ? res() : rej(Error("Email already exist."));
  });
})